import { useMemo } from "react";

import { useLevelContext } from "sj-ui-toolkit/src/atlas/contexts/Level/LevelContextProvider";
import { useEnrollments } from "sj-ui-toolkit/src/api/hooks";
import { useBreadcrumb } from "sj-ui-toolkit/src/atlas/hooks/useBreadcrumbs";
import { PageBreadcrumb } from "sj-ui-toolkit/src/atlas/components";

import { LearninGrid } from "../LearninGrid/LearninGrid";

const QuestsPage = () => {
  const { quests, isLoading } = useLevelContext();
  const { data: enrollments = [] } = useEnrollments();

  useBreadcrumb({ label: "Quests", route: "/quests", display: "page" });

  const items = useMemo(() => {
    if (quests.length === 0) return [];
    const enrolledQuestRoleIds = new Set(
      (enrollments ?? [])
        .filter(e => e.enrollmentType === "quest" && e.roleId != null)
        .map(e => e.roleId)
    );

    const getQuestPathId = quest => quest.paths?.slice(-1)[0]?.id ?? quest.role?.id;

    return (quests ?? [])
      .map(q => {
        const questPathId = getQuestPathId(q);
        if (questPathId == null || enrolledQuestRoleIds.has(questPathId)) return null;

        return {
          id: questPathId,
          name: q.name,
          description: q.description,
          status: q.status,
        };
      })
      .filter(Boolean);
  }, [quests, enrollments]);

  return (
    <div data-test-id="learn-quests-page">
      <PageBreadcrumb />
      <LearninGrid
        items={items}
        loading={isLoading}
        variant="indigo"
        pathType="Quest"
        title="Quests"
        searchInputId="quests-search"
      />
    </div>
  );
};

export default QuestsPage;
